import axiosInstance from './axios-instance';

export const getFileExtension = (fileName: string) => {
  return fileName?.split('.')?.pop() || 'png'
}
import { isMutationSuccess } from "./cache-utils";
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const withScopedAccountId = (payload: any) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const scopedAccountId = getScopedAccountId(payload.accountId);
  if (!(scopedAccountId > 0)) {
    return payload;
  }

  return {
    ...payload,
    accountId: scopedAccountId,
  };
};

const editDraperyOrderDesign = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      `/draperyOrderDesign/edit`,
      withScopedAccountId(payload)
    );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

    return response.data;
  } catch (error) {
    console.error('Error edit drapery order design:', error);
    throw error;
  }
};
const addDraperyOrderDesign = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `/draperyOrderDesign/add`,
      withScopedAccountId(payload)
    );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

    return response.data;
  } catch (error) {
    console.error('Error add drapery order design:', error);
    throw error;
  }
};

export { editDraperyOrderDesign, addDraperyOrderDesign };
